import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import type { Favorite, StoredFavoritePositions } from 'models/favorites.model';
import type { OfferBase } from 'models/offer.model';
import { FavoriteStoreService } from 'shared/services/favorite-store.service';
import { FavoriteService } from 'shared/services/favorite.service';
import { StoreService } from 'shared/services/store.service';

import { EditFavoriteComponent } from '../edit-favorite.component';

@Component({
  selector: 'app-edit-favorite-modal',
  templateUrl: './edit-favorite-modal.component.html',
  styleUrls: ['./edit-favorite-modal.component.scss']
})
export class EditFavoriteModalComponent implements OnInit {
  @ViewChild(EditFavoriteComponent) editFavoriteComponent!: EditFavoriteComponent;

  offer!: OfferBase;

  favorite!: Favorite;

  get form(): UntypedFormGroup {
    return this.editFavoriteComponent.form;
  }

  constructor(
    private favoriteService: FavoriteService,
    private favoriteStoreService: FavoriteStoreService,
    private storeService: StoreService
  ) { }

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    this.storeService.getCurrentPosition()
      .pipe(take(1))
      .subscribe((currentPosition) => {
        this.favorite = currentPosition as unknown as Favorite;
      });
  }

  onSubmit(): Observable<StoredFavoritePositions> {
    const updatedTitle = this.form.controls.name.value;

    return updatedTitle !== this.favorite.title
      ? this.favoriteService.updateTitle(this.favorite, updatedTitle)
      : this.favoriteStoreService.getFavorites();
  }
}
